<template>
  <div>
    <!-- Modal -->
    <div id="edit-modal" class="modal fade" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header d-flex align-items-center">
            <h2 class="text-center">Edit user</h2>
            <button type="button" class="close p-0 m-0" data-dismiss="modal">&times;</button>
          </div>
          <div class="modal-body">
            <form @submit="submit" class="product-form">
              <div class="row">
                <div class="col-lg-12">
                  <label for="">
                    <span>Name:</span>
                    <input type="text" v-model="user.name" class="form-control">
                  </label>
                  <label for="">
                    <span>Username:</span>
                    <input type="text" v-model="user.username" class="form-control">
                  </label>
                  <label for="">
                    <span>Organization:</span>
                    <input type="text" v-model="user.organization" class="form-control">
                  </label>
                  <label for="">
                    <span>Account:</span>
                    <input type="text" v-model="user.account" class="form-control">
                  </label>
                  <label for="">
                    <span>Password:</span>
                    <input type="password" v-model="user.password" class="form-control">
                  </label>
                  <label for="">
                    <span>Role:</span>
                    <select v-model="user.role" class="form-control">
                      <option value="admin">Admin</option>
                      <option value="martinellis">Martinellis</option>
                      <option value="1868">1868</option>
                    </select>
                  </label>
                  <label for="" class="checkbox-icon">
                    <span class="text-left">Enabled:</span>
                    <label class="checkbox-container">
                      <input v-model="user.is_enabled" type="checkbox">
                      <span class="checkmark"></span>
                    </label>
                  </label>
                </div>
              </div>
              <div class="col-lg-12 d-flex justify-content-center mt-3">
                <button type="submit" :disabled="this.$store.getters.apiStatus == 'loading'" class="btn btn-success">
                  <div v-if="this.$store.getters.apiStatus != 'loading'">Update</div>
                  <div v-else class="loader"><Loader></Loader></div>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import User from '@/models/user'
export default{
  name: 'UserModel',
  props: ['user'],
  data () {
    return {}
  },
  coumputed: {
    user () {
      return new User(this.user)
    }
  },
  methods: {
    submit (event) {
      event.preventDefault()
      const user = this.user
      this.$store.dispatch('editUser', user)
        .then(() => {
          this.$toast.success('User updated successfully')
          // eslint-disable-next-line no-undef
          $('#edit-modal .close').click()
          this.$parent.fetchAllUsers()
        })
        .catch((err) => this.$toast.error(err.response.data.message))
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/EditUserModal.vue